import { atom } from "jotai";

export const STORAGE_KEY = "green-screen-verification-seen";

/**
 * Get initial value from localStorage
 */
const getInitialSeenValue = (): boolean => {
  if (typeof window === "undefined") return false;
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "true";
};

/**
 * Track if user has seen the verification modal
 * Persisted in localStorage to show only once across sessions
 */
export const greenScreenVerificationSeenAtom = atom<boolean>(getInitialSeenValue());

/**
 * Control modal visibility
 */
export const greenScreenVerificationModalOpenAtom = atom<boolean>(false);

/**
 * Signals that user clicked "Skip & Add to Cart" (desktop) or "Skip" (mobile)
 * - Desktop: AddToCartToolbar listens and triggers add-to-cart flow
 * - Mobile: MobileButtonNavigation listens and proceeds to next step
 * Reset after processing
 */
export const proceedWithActionAtom = atom<boolean>(false);
